import { render, staticRenderFns } from "./ZupanijaEdit.vue?vue&type=template&id=3ede3310&scoped=true&"
import script from "./ZupanijaEdit.vue?vue&type=script&lang=js&"
export * from "./ZupanijaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ede3310",
  null
  
)

export default component.exports